<template>
  <div :class="classList">
    <label
      v-if="label"
      :class="'display-flex' + (labelSpaceBottom ? ' mb-0' : '')"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span>
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div class="position-relative input-container">
      <input
        ref="input"
        :type="type === 'password' ? 'password' : 'text'"
        class="form-control input-text"
        :class="!label && hasSpaceTop ? 'space-top' : ''"
        v-model="inputVal"
        spellcheck="true"
        :maxlength="maxLength"
        :placeholder="placeholder"
        :disabled="isDisabled"
        @input="handleOnInput()"
        @blur="handleBlurField()"
      />
      <SpeechInput
        class="speech-input"
        :field="builderField"
        @input="handleSpeechInput($event)"
      />
    </div>
    <p class="required-message" v-if="!inputVal && submitClicked && isRequired">
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
    <p
      class="required-message"
      v-if="(submitClicked || isBlur) && validationErrorMessage"
    >
      {{ validationErrorMessage }}
    </p>
    <p class="required-message" v-if="isInvalidPhone">
      Please enter a valid phone number.
    </p>
    <div
      class="button-group mt-2"
      v-if="listDisplayButtons && listDisplayButtons.length"
    >
      <button
        v-for="button of listDisplayButtons"
        :key="'button-' + button.id"
        @click="handleClickButton(button)"
        class="btn btn-secondary mr-1"
      >
        {{ getLabelByKeys(button.keyLangLabel) }}
      </button>
    </div>
  </div>
</template>
<script>
/* This component includes a label, and a textbox
Any error of textbox (for example: required field, invalid character, exceed length ...) is showed in this component */
import { TEXTBOX_INPUT_TYPE } from "../../../constants/custom-define-type";
import { REGEX_VALID_NUMBER } from "../../../constants/regex";
import axios from "axios";
import SpeechInput from "../speech/SpeechInput.vue";

export default {
  name: "TextBoxWithLabel",
  components: {
    SpeechInput,
  },
  props: {
    /* Name of the textbox component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // Input value, which is used for v-model
    value: [String, Number],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true,
    },
    // Type of input: text or number
    type: {
      type: String,
      default: TEXTBOX_INPUT_TYPE.TEXT,
    },
    // Validation for input
    validation: {
      type: Array,
      default: () => [],
    },
    placeholder: String,
    // Max length of input
    maxLength: {
      type: Number,
    },
    //used if type is a number enforce a max input
    maxNumber: {
      type: Number,
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // Initial value
    defaultValue: String,
    hasSpaceTop: {
      type: Boolean,
      default: true,
    },
    labelSpaceBottom: {
      type: Boolean,
      default: false,
    },
    builderField: Object,
    buttonGroups: Array, // List of buttons attached by the end of textbox
    formData: Object, // data of all fields of the form
  },
  created() {
    if (this.defaultValue && !this.value) {
      this.$emit("input", this.defaultValue);
    }
  },
  data() {
    return {
      isBlur: false,
      isInvalidPhone: false,
    };
  },
  // created() {
  //   if (this.validation.length > 0) {
  //     this.$emit("input", "thuy@enginehire.ca");
  //   } else {
  //     this.$emit("input", this.label);
  //   }
  // },
  computed: {
    isPhoneField() {
      if (!this.builderField) {
        return false;
      }
      if (this.builderField.isAPhoneNumber) {
        return true;
      }
      if (
        this.builderField.model &&
        this.builderField.model.includes("info__custom_phone")
      ) {
        return true;
      }
      return ["phone", "phone2"].includes(this.builderField.model);
    },
    listDisplayButtons() {
      if (!this.buttonGroups || !this.buttonGroups.length) {
        return null;
      }
      if (this.inputVal) {
        return this.buttonGroups;
      }
      return this.buttonGroups.filter((button) => !button.showIfSelect);
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    validationErrorMessage() {
      if (!this.inputVal) {
        return;
      }
      for (const validateItem of this.validation) {
        try {
          if (validateItem && validateItem.regex) {
            if (!validateItem.regex.test(this.inputVal)) {
              return validateItem.message;
            }
          }
        } catch (e) {}
      }
    },
  },
  methods: {
    async handleBlurField() {
      this.$emit("blur");
      this.isBlur = true;
      // Check if phone number is invalid
      if (this.isPhoneField) {
        const res = await axios.post(
          this.appendBackgroundParam(`/validate-phone-number/`),
          {
            phone: this.inputVal,
            agency: this.$store.getters.agencyID,
            country: this.formData ? this.formData.country : null,
          }
        );
        if (res && res.data) {
          this.isInvalidPhone = res.data.code === -1;
        }
      }
    },
    handleOnInput() {
      if (this.type && REGEX_VALID_NUMBER[this.type]) {
        const oldVal = this.inputVal;
        this.$nextTick(() => {
          if (!REGEX_VALID_NUMBER[this.type].test(this.inputVal)) {
            this.inputVal = oldVal;
            this.$refs.input.blur();
            setTimeout(() => {
              this.$refs.input.focus();
            });
          }
          if (this.type && this.type != "TEXT" && this.maxNumber) {
            if (Number(this.inputVal) > Number(this.maxNumber)) {
              this.inputVal = oldVal;
              this.$refs.input.blur();
              setTimeout(() => {
                this.$refs.input.focus();
              });
            }
          }
        });
      }
    },
    handleClickButton(button) {
      this.$emit("clickBtn", button.id);
    },
    handleSpeechInput(inputText) {
      this.inputVal = inputText;
    },
  },
};
</script>

<style scoped>
.description {
  font-size: 80%;
  font-weight: 400;
}

.space-top {
  margin-top: 1em;
}

.tab-label label.display-flex {
  margin-top: 0px !important;
}
.tab-label {
  margin-bottom: 0px !important;
}

.speech-input {
  position: absolute;
  right: 0;
  bottom: 0;
}

.input-text {
  padding-right: 1.3em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/TextBoxWithLabel.vue